/**
 * Given a resource type returns the prefix
 * of the Ruby document class name (Business or Personal)
 * @param {string} resourceType A string representing the resource type of an entity ('Business' or 'Gurantor')
 * @returns {string}
 */
const getDocPrefix = (resourceType) => {
  if (resourceType === 'Business') {
    return resourceType
  } else if (resourceType === 'Guarantor') {
    return 'Personal'
  }
}

/**
 * Finds a tax return bucket matching a year, based on an entity's current tax returns
 * @param {number}   year The year of the tax return bucket being searched for
 * @param {Object[]} taxReturns An array of an entity's tax returns
 * @param {Object[]} documents An array of an entity's documents
 * @param {string}   resourceType The entity's resource type ('Business' or 'Guarantor')
 */
export default (year, fiscalYears, taxReturns, documents, resourceType) => {
  // const taxReturnYears = taxReturns.map(tr => parseInt(tr.year, 10)).sort((a, b) => a - b).reverse()
  const taxYears = fiscalYears.filter(fy => fy.period !== 'interim').map(fy => fy.year)
  const idx = taxYears.indexOf(year)
  const docPrefix = getDocPrefix(resourceType)
  if (idx < 0) {
    return null
  }
  switch (idx) {
    case 0:
      return documents.find(doc => doc.type === `Document::${docPrefix}TaxReturnLastYear`)
    case 1:
      return documents.find(doc => doc.type === `Document::${docPrefix}TaxReturnPriorYear`)
    case 2:
      return documents.find(doc => doc.type === `Document::${docPrefix}TaxReturnTwoYearsPrior`)
    default:
      return null
  }
}